export interface CityPlace {
    displayText: string;
    placeId?: string;
    city?: string;
    region?: string;
    country?: string;
    lat?: number | null;
    lng?: number | null;
}

/**
 * One Latin letter is too broad to spend a Places request on. A single
 * non-ASCII character can be a whole city name, so those still search.
 * Keep this in step with backend/src/services/cityLookup.js.
 */
export function isSearchableCityQuery(query: string): boolean {
    const compact = query.trim().replace(/\s+/g, '');
    if ([...compact].length >= 2) return true;
    return compact.length > 0 && /[^\u0000-\u007f]/.test(compact);
}

export function emptyCityPlace(): CityPlace {
    return {
        displayText: '',
        placeId: '',
        city: '',
        region: '',
        country: '',
        lat: null,
        lng: null,
    };
}

export function citySelectionFromText<T extends { displayText?: string } | null | undefined>(
    text: string,
    selected: T,
): { ok: true; location: T | null } | { ok: false; error: string } {
    const typed = text.trim();
    const chosen = selected?.displayText?.trim() || '';
    if (!typed) return { ok: true, location: null };
    if (!chosen || typed.toLowerCase() !== chosen.toLowerCase()) {
        return { ok: false, error: 'Pick a city from the suggestions' };
    }
    return { ok: true, location: selected ?? null };
}
